import { KeyRound, LockKeyhole, ShieldCheck } from "lucide-react";
import type { ReactNode } from "react";

import { Brand } from "./brand";

export function AuthFrame({ children, title, description }: { children: ReactNode; title: string; description: string }) {
  return (
    <main className="min-h-screen bg-background lg:grid lg:grid-cols-[minmax(0,0.86fr)_minmax(32rem,1.14fr)]">
      <aside className="hidden min-h-screen flex-col bg-rail p-10 text-white lg:flex xl:p-14">
        <Brand inverted />
        <div className="my-auto max-w-md">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold text-rail-muted">
            <span className="size-2 rounded-full bg-signal" />
            Private automation control room
          </p>
          <h2 className="font-display text-[2.7rem] font-bold leading-[1.08] tracking-[-0.05em]">
            Calm controls for a market that never sits still.
          </h2>
          <p className="mt-5 text-[15px] leading-7 text-rail-muted">
            Hyper Profits explains every ETH/USD decision, accounts for Kraken fees, and keeps emergency controls within reach.
          </p>
        </div>
        <div className="grid gap-3 border-t border-white/10 pt-6 text-xs text-rail-muted">
          <p className="flex items-center gap-2"><LockKeyhole className="size-4 text-signal" /> Encrypted credential storage</p>
          <p className="flex items-center gap-2"><KeyRound className="size-4 text-signal" /> No withdrawal permission required</p>
          <p className="flex items-center gap-2"><ShieldCheck className="size-4 text-signal" /> Fail-closed live trading checks</p>
        </div>
      </aside>
      <section className="flex min-h-screen items-center justify-center px-5 py-10 sm:px-8 lg:px-12">
        <div className="w-full max-w-md">
          <Brand className="mb-12 lg:hidden" />
          <header className="mb-8">
            <h1 className="font-display text-3xl font-bold tracking-[-0.04em] text-foreground">{title}</h1>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">{description}</p>
          </header>
          {children}
          <p className="mt-8 border-t border-border pt-5 text-xs leading-5 text-muted-foreground">
            Live trading uses real funds. Returns are uncertain, and the full amount committed to a position can be lost.
          </p>
        </div>
      </section>
    </main>
  );
}
